export default "__VITE_ASSET__C36ha8KF__"